import { align16 } from "./vapConfig";

/**
 * PACKED_ALPHA 拼帧：左半 RGB（解预乘），右半 alpha 灰度。
 * 与 Android BenchmarkVideoEncoder.Mode.PACKED_ALPHA 布局一致。
 */
export function packAlphaFrame(
  source: HTMLCanvasElement,
  srcW: number,
  srcH: number,
): HTMLCanvasElement {
  const encW = align16(srcW * 2);
  const encH = align16(srcH);
  const out = document.createElement("canvas");
  out.width = encW;
  out.height = encH;
  const outCtx = out.getContext("2d");
  if (!outCtx) {
    throw new Error("无法创建 VAP 拼帧 canvas");
  }

  outCtx.fillStyle = "#000";
  outCtx.fillRect(0, 0, encW, encH);

  const srcCtx = source.getContext("2d");
  if (!srcCtx) {
    throw new Error("无法读取源帧");
  }
  const img = srcCtx.getImageData(0, 0, srcW, srcH);
  const rgb = outCtx.createImageData(srcW, srcH);
  const alpha = outCtx.createImageData(srcW, srcH);

  for (let i = 0; i < img.data.length; i += 4) {
    const r = img.data[i];
    const g = img.data[i + 1];
    const b = img.data[i + 2];
    const a = img.data[i + 3];
    const alphaNorm = a / 255;
    const invA = alphaNorm > 0.004 ? alphaNorm : 0.004;

    rgb.data[i] = Math.min(255, Math.round(r / invA));
    rgb.data[i + 1] = Math.min(255, Math.round(g / invA));
    rgb.data[i + 2] = Math.min(255, Math.round(b / invA));
    rgb.data[i + 3] = 255;

    alpha.data[i] = a;
    alpha.data[i + 1] = a;
    alpha.data[i + 2] = a;
    alpha.data[i + 3] = 255;
  }

  const rgbCanvas = document.createElement("canvas");
  rgbCanvas.width = srcW;
  rgbCanvas.height = srcH;
  rgbCanvas.getContext("2d")!.putImageData(rgb, 0, 0);

  const alphaCanvas = document.createElement("canvas");
  alphaCanvas.width = srcW;
  alphaCanvas.height = srcH;
  alphaCanvas.getContext("2d")!.putImageData(alpha, 0, 0);

  // 顶部对齐（vapc rgbFrame/aFrame 原点在左上）
  outCtx.drawImage(rgbCanvas, 0, 0);
  outCtx.drawImage(alphaCanvas, srcW, 0);

  return out;
}
